var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding-bottom":"0px"}},[_c('v-container',{},[_c('v-row',{staticClass:"above-the-fold flex-column align-center"},[_c('v-col',{staticClass:"d-flex justify-center align-center"},[_c('analytics-home')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }